import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable()
export class ClinicalAssessmentApi {
  private readonly apiController: string = 'clinicalassessment';

  constructor(private api: HttpService) { }

  list<type>(url: string,queryparams?:HttpParams): Observable<type> {
    if(!!queryparams){
      const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
      return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"},params:queryparams});
    }
    else{
      const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
      return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
    }
   
  }

  getById<type>(url : string,queryparams?:HttpParams): Observable<type> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directGet(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"},params:queryparams});
  }
  getassessmentById(url : string,queryparams:HttpParams): Observable<any>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directGet(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"},params:queryparams});
  }

  add<type,returnType>(url:string, data:type,queryparams?:HttpParams):Observable<returnType>{
    if(!!queryparams){
      let header = new HttpHeaders();
      header.append('Content-Type', 'applications/json');
      header.append('Accept','application/vnd.ezovion.hateoas+json');
      return this.api.post( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"},params:queryparams});
    }
    else{
      let header = new HttpHeaders();
      header.append('Content-Type', 'applications/json');
      header.append('Accept','application/vnd.ezovion.hateoas+json');
      return this.api.post( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
    }
   
  }

  update(url:string, data:any,queryparams?:HttpParams):Observable<any>{
    if(!!queryparams){
      let header = new HttpHeaders();
      header.append('Content-Type', 'applications/json');
      header.append('Accept','application/vnd.ezovion.hateoas+json');
      return this.api.directPut( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"},params:queryparams});    
    }
    else{
      let header = new HttpHeaders();
      header.append('Content-Type', 'applications/json');
      header.append('Accept','application/vnd.ezovion.hateoas+json');
      return this.api.directPut( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
    }
    
  }
  updateassessTransaction<type>(url:string, data:type,queryparams:HttpParams):Observable<any>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.post( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"},params:queryparams});
  }
  
  searchList(url: string, data:any, options?: any): Observable<any[]> {    
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    return this.api.post(url,data,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }
  
  delete(url: string):Observable<any>{
    return this.api.directDelete(url);
  }
}
